import { render, staticRenderFns } from "./EduSubjectCell.vue?vue&type=template&id=8a710e64&"
import script from "./EduSubjectCell.vue?vue&type=script&lang=ts&"
export * from "./EduSubjectCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports